import { type IOrderOffers } from '@/types/IOrder';

export const calculateTotalCostWithDelivery = (
  orderOffers: IOrderOffers[],
  deliveryAmount?: number | null
): number => {
  const totalCostProducts = orderOffers.reduce((acc, el) => {
    return acc + el.sale_price * el.count;
  }, 0);

  if (deliveryAmount !== null && deliveryAmount !== undefined) {
    return totalCostProducts + deliveryAmount;
  }

  return totalCostProducts;
};
